<script>
    import { Router, Link, Route } from "svelte-routing";
    import ListRoute from "./list.html";
    import VewJoinRequest from "./viewJoinRequest.html";
</script>

<Router>
    <Route path="">
        <ListRoute></ListRoute>
    </Route>
    <Route path="view/:id" let:params>
        <VewJoinRequest questionId="{params.id}"></VewJoinRequest>
    </Route>
</Router>